import {
  dimensionTypes,
  getDefaultSequence,
  getDefaultSequenceDimensions,
  retentionViews,
} from '../../constants/retention';

const composeInitialState = {
  firstEvent: null,
  returnEvent: null,
  dimensionType: dimensionTypes.DAILY,
  options: {
    view: retentionViews.TABLE,
    views: Object.values(retentionViews),
    trendLine: false,
    averageLine: false,
    medianLine: false,
    adaptive: false,
    isExpand: false,
  },
};

const retentionCompose = (state = composeInitialState, action) => {
  switch (action.type) {
    case 'DASHBOARD_CHANGE_RETENTION_FIRST_EVENT':
      return {
        ...state,
        firstEvent: action.event,
      };

    case 'DASHBOARD_CHANGE_RETENTION_RETURN_EVENT':
      return {
        ...state,
        returnEvent: action.event,
      };

    case 'DASHBOARD_CHANGE_RETENTION_DIMENSION_TYPE':
      return {
        ...state,
        dimensionType: action.dimensionType,
        customSequence: getDefaultSequence(state.customSequenceType, action.dimensionType),
        customSequenceDimensions: getDefaultSequenceDimensions(
          state.customSequenceType,
          action.dimensionType
        ),
      };

    case 'DASHBOARD_CHANGE_RETENTION_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
        },
      };

    case 'DASHBOARD_TOGGLE_RETENTION_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'DASHBOARD_TOGGLE_RETENTION_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'DASHBOARD_TOGGLE_RETENTION_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'DASHBOARD_TOGGLE_RETENTION_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    default:
      return state;
  }
};

export default retentionCompose;

export const getFirstEvent = (state) => state.firstEvent;

export const getReturnEvent = (state) => state.returnEvent;

export const getDimensionType = (state) => state.dimensionType;

export const getRetentionSimpleOptions = (state) => state.options;
